export enum Safety {
    CONCIERGE = 'CONCIERGE',
    CLOSED_AREA = 'CLOSED_AREA',
    GUARDED_AREA = 'GUARDED_AREA'
}
